/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dealcancelled_Notice2Inputs */

const en_coinvestments_dealcancelled_notice2 = /** @type {(inputs: Coinvestments_Dealcancelled_Notice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This deal is cancelled and is now read-only.`)
};

/**
* | output |
* | --- |
* | "This deal is cancelled and is now read-only." |
*
* @param {Coinvestments_Dealcancelled_Notice2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dealcancelled_notice2 = /** @type {((inputs?: Coinvestments_Dealcancelled_Notice2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dealcancelled_Notice2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dealcancelled_notice2(inputs)
});
export { coinvestments_dealcancelled_notice2 as "coInvestments_dealCancelled_notice" }